import { REGISTER_USER_WITH_INSURANCE_NUMBER_REQUEST } from 'redux/actions';
import { arrayContains } from 'utils';

export const isRegisterHealthInsuranceLoading = (state) =>
  arrayContains(state.entities.users.openRequests, [REGISTER_USER_WITH_INSURANCE_NUMBER_REQUEST]);
